"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var _data_1 = __importDefault(require("./_data"));
function default_1(name, opts) {
    if (opts === void 0) { opts = {}; }
    var result = /^[\w](?:[\w-]{0,63}[\w])?$/.test(name);
    if (opts.reserved) {
        return result && _data_1["default"].reserved.indexOf(name) === -1;
    }
    return result;
}
exports["default"] = default_1;
